module.exports = __webpack_public_path__ + "img/imagemissing3.7e711c07.jpg";